import React from 'react';

import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {WithDevice} from "../../../../core/components/composers/with-device";
import {AthleteWidgetHeaderPlaceholder} from "./athlete-widget.header.placeholder";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import classNames from "classnames";
import styles from "../../styles/athlete-widget.placeholder.module.scss";
import {AthleteWidgetDetailsPlaceholder} from "./details/athlete-widget.details.placeholder";

import {AthleteWidgetStatsPlaceholder} from "./athlete-widget.stats.placeholder";
import {AthleteWidgetLastMatchesPlaceholder} from "./athlete-widget.last-matches.placeholder";

export class AthleteWidgetPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const AthleteWidgetPlaceholder = WithDevice(({device}) => {
  return (
    <>
      <AthleteWidgetHeaderPlaceholder device={device}/>
      <AthleteWidgetDetailsPlaceholder device={device}/>
      <AthleteWidgetStatsPlaceholder device={device}/>
      <AthleteWidgetLastMatchesPlaceholder device={device}/>
      <PlaceholderWrapperComponent className={classNames(styles.blank)}/>
      <PlaceholderWrapperComponent className={classNames(styles.blank)}/>
    </>
  )
});
